/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthenticatedRouteRouteImport } from "./routes/_authenticated/route";
import { Route as EntrarRouteImport } from "./routes/entrar";
import { Route as PrivacidadeRouteImport } from "./routes/privacidade";
import { Route as TermosRouteImport } from "./routes/termos";
import { Route as AuthenticatedAgendaRouteImport } from "./routes/_authenticated/agenda";
import { Route as AuthenticatedAtendimentoRouteImport } from "./routes/_authenticated/atendimento";
import { Route as AuthenticatedAutomacaoRouteImport } from "./routes/_authenticated/automacao";
import { Route as AuthenticatedConfiguracoesRouteImport } from "./routes/_authenticated/configuracoes";
import { Route as AuthenticatedConhecimentoRouteImport } from "./routes/_authenticated/conhecimento";
import { Route as AuthenticatedConversasRouteImport } from "./routes/_authenticated/conversas";
import { Route as AuthenticatedMarketingRouteImport } from "./routes/_authenticated/marketing";
import { Route as AuthenticatedPainelRouteImport } from "./routes/_authenticated/painel";
import { Route as AuthenticatedPipelineRouteImport } from "./routes/_authenticated/pipeline";
import { Route as AuthenticatedPlataformaRouteImport } from "./routes/_authenticated/plataforma";
import { Route as AuthenticatedProdutosRouteImport } from "./routes/_authenticated/produtos";
import { Route as AuthenticatedRelatoriosRouteImport } from "./routes/_authenticated/relatorios";
import { Route as AuthenticatedTarefasRouteImport } from "./routes/_authenticated/tarefas";
import { Route as ConviteTokenRouteImport } from "./routes/convite.$token";
import { Route as AuthenticatedAgenteIaIndexRouteImport } from "./routes/_authenticated/agente-ia.index";
import { Route as AuthenticatedAgenteIaFlowIdRouteImport } from "./routes/_authenticated/agente-ia.$flowId";
import { Route as AuthenticatedContatosIndexRouteImport } from "./routes/_authenticated/contatos.index";
import { Route as AuthenticatedContatosContactIdRouteImport } from "./routes/_authenticated/contatos.$contactId";
import { Route as AuthenticatedFormulariosIndexRouteImport } from "./routes/_authenticated/formularios.index";
import { Route as AuthenticatedFormulariosFlowIdRouteImport } from "./routes/_authenticated/formularios.$flowId";
import { Route as AuthenticatedLeadsIndexRouteImport } from "./routes/_authenticated/leads.index";
import { Route as AuthenticatedLeadsLeadIdRouteImport } from "./routes/_authenticated/leads.$leadId";
import { Route as AuthenticatedTypechatIndexRouteImport } from "./routes/_authenticated/typechat.index";
import { Route as AuthenticatedTypechatFlowIdRouteImport } from "./routes/_authenticated/typechat.$flowId";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const EntrarRoute = EntrarRouteImport.update({
  id: "/entrar",
  path: "/entrar",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacidadeRoute = PrivacidadeRouteImport.update({
  id: "/privacidade",
  path: "/privacidade",
  getParentRoute: () => rootRouteImport,
} as any);
const TermosRoute = TermosRouteImport.update({
  id: "/termos",
  path: "/termos",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAgendaRoute = AuthenticatedAgendaRouteImport.update({
  id: "/agenda",
  path: "/agenda",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedAtendimentoRoute =
  AuthenticatedAtendimentoRouteImport.update({
    id: "/atendimento",
    path: "/atendimento",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedAutomacaoRoute = AuthenticatedAutomacaoRouteImport.update({
  id: "/automacao",
  path: "/automacao",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedConfiguracoesRoute =
  AuthenticatedConfiguracoesRouteImport.update({
    id: "/configuracoes",
    path: "/configuracoes",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedConhecimentoRoute =
  AuthenticatedConhecimentoRouteImport.update({
    id: "/conhecimento",
    path: "/conhecimento",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedConversasRoute = AuthenticatedConversasRouteImport.update({
  id: "/conversas",
  path: "/conversas",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedMarketingRoute = AuthenticatedMarketingRouteImport.update({
  id: "/marketing",
  path: "/marketing",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedPainelRoute = AuthenticatedPainelRouteImport.update({
  id: "/painel",
  path: "/painel",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedPipelineRoute = AuthenticatedPipelineRouteImport.update({
  id: "/pipeline",
  path: "/pipeline",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedPlataformaRoute = AuthenticatedPlataformaRouteImport.update({
  id: "/plataforma",
  path: "/plataforma",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedProdutosRoute = AuthenticatedProdutosRouteImport.update({
  id: "/produtos",
  path: "/produtos",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedRelatoriosRoute = AuthenticatedRelatoriosRouteImport.update({
  id: "/relatorios",
  path: "/relatorios",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedTarefasRoute = AuthenticatedTarefasRouteImport.update({
  id: "/tarefas",
  path: "/tarefas",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const ConviteTokenRoute = ConviteTokenRouteImport.update({
  id: "/convite/$token",
  path: "/convite/$token",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAgenteIaIndexRoute =
  AuthenticatedAgenteIaIndexRouteImport.update({
    id: "/agente-ia/",
    path: "/agente-ia/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedAgenteIaFlowIdRoute =
  AuthenticatedAgenteIaFlowIdRouteImport.update({
    id: "/agente-ia/$flowId",
    path: "/agente-ia/$flowId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedContatosIndexRoute =
  AuthenticatedContatosIndexRouteImport.update({
    id: "/contatos/",
    path: "/contatos/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedContatosContactIdRoute =
  AuthenticatedContatosContactIdRouteImport.update({
    id: "/contatos/$contactId",
    path: "/contatos/$contactId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedFormulariosIndexRoute =
  AuthenticatedFormulariosIndexRouteImport.update({
    id: "/formularios/",
    path: "/formularios/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedFormulariosFlowIdRoute =
  AuthenticatedFormulariosFlowIdRouteImport.update({
    id: "/formularios/$flowId",
    path: "/formularios/$flowId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedLeadsIndexRoute = AuthenticatedLeadsIndexRouteImport.update({
  id: "/leads/",
  path: "/leads/",
  getParentRoute: () => AuthenticatedRouteRoute,
} as any);
const AuthenticatedLeadsLeadIdRoute =
  AuthenticatedLeadsLeadIdRouteImport.update({
    id: "/leads/$leadId",
    path: "/leads/$leadId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedTypechatIndexRoute =
  AuthenticatedTypechatIndexRouteImport.update({
    id: "/typechat/",
    path: "/typechat/",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);
const AuthenticatedTypechatFlowIdRoute =
  AuthenticatedTypechatFlowIdRouteImport.update({
    id: "/typechat/$flowId",
    path: "/typechat/$flowId",
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/entrar": typeof EntrarRoute;
  "/privacidade": typeof PrivacidadeRoute;
  "/termos": typeof TermosRoute;
  "/agenda": typeof AuthenticatedAgendaRoute;
  "/atendimento": typeof AuthenticatedAtendimentoRoute;
  "/automacao": typeof AuthenticatedAutomacaoRoute;
  "/configuracoes": typeof AuthenticatedConfiguracoesRoute;
  "/conhecimento": typeof AuthenticatedConhecimentoRoute;
  "/conversas": typeof AuthenticatedConversasRoute;
  "/marketing": typeof AuthenticatedMarketingRoute;
  "/painel": typeof AuthenticatedPainelRoute;
  "/pipeline": typeof AuthenticatedPipelineRoute;
  "/plataforma": typeof AuthenticatedPlataformaRoute;
  "/produtos": typeof AuthenticatedProdutosRoute;
  "/relatorios": typeof AuthenticatedRelatoriosRoute;
  "/tarefas": typeof AuthenticatedTarefasRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/agente-ia/$flowId": typeof AuthenticatedAgenteIaFlowIdRoute;
  "/contatos/$contactId": typeof AuthenticatedContatosContactIdRoute;
  "/formularios/$flowId": typeof AuthenticatedFormulariosFlowIdRoute;
  "/leads/$leadId": typeof AuthenticatedLeadsLeadIdRoute;
  "/typechat/$flowId": typeof AuthenticatedTypechatFlowIdRoute;
  "/agente-ia/": typeof AuthenticatedAgenteIaIndexRoute;
  "/contatos/": typeof AuthenticatedContatosIndexRoute;
  "/formularios/": typeof AuthenticatedFormulariosIndexRoute;
  "/leads/": typeof AuthenticatedLeadsIndexRoute;
  "/typechat/": typeof AuthenticatedTypechatIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/entrar": typeof EntrarRoute;
  "/privacidade": typeof PrivacidadeRoute;
  "/termos": typeof TermosRoute;
  "/agenda": typeof AuthenticatedAgendaRoute;
  "/atendimento": typeof AuthenticatedAtendimentoRoute;
  "/automacao": typeof AuthenticatedAutomacaoRoute;
  "/configuracoes": typeof AuthenticatedConfiguracoesRoute;
  "/conhecimento": typeof AuthenticatedConhecimentoRoute;
  "/conversas": typeof AuthenticatedConversasRoute;
  "/marketing": typeof AuthenticatedMarketingRoute;
  "/painel": typeof AuthenticatedPainelRoute;
  "/pipeline": typeof AuthenticatedPipelineRoute;
  "/plataforma": typeof AuthenticatedPlataformaRoute;
  "/produtos": typeof AuthenticatedProdutosRoute;
  "/relatorios": typeof AuthenticatedRelatoriosRoute;
  "/tarefas": typeof AuthenticatedTarefasRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/agente-ia/$flowId": typeof AuthenticatedAgenteIaFlowIdRoute;
  "/contatos/$contactId": typeof AuthenticatedContatosContactIdRoute;
  "/formularios/$flowId": typeof AuthenticatedFormulariosFlowIdRoute;
  "/leads/$leadId": typeof AuthenticatedLeadsLeadIdRoute;
  "/typechat/$flowId": typeof AuthenticatedTypechatFlowIdRoute;
  "/agente-ia": typeof AuthenticatedAgenteIaIndexRoute;
  "/contatos": typeof AuthenticatedContatosIndexRoute;
  "/formularios": typeof AuthenticatedFormulariosIndexRoute;
  "/leads": typeof AuthenticatedLeadsIndexRoute;
  "/typechat": typeof AuthenticatedTypechatIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteRouteWithChildren;
  "/entrar": typeof EntrarRoute;
  "/privacidade": typeof PrivacidadeRoute;
  "/termos": typeof TermosRoute;
  "/_authenticated/agenda": typeof AuthenticatedAgendaRoute;
  "/_authenticated/atendimento": typeof AuthenticatedAtendimentoRoute;
  "/_authenticated/automacao": typeof AuthenticatedAutomacaoRoute;
  "/_authenticated/configuracoes": typeof AuthenticatedConfiguracoesRoute;
  "/_authenticated/conhecimento": typeof AuthenticatedConhecimentoRoute;
  "/_authenticated/conversas": typeof AuthenticatedConversasRoute;
  "/_authenticated/marketing": typeof AuthenticatedMarketingRoute;
  "/_authenticated/painel": typeof AuthenticatedPainelRoute;
  "/_authenticated/pipeline": typeof AuthenticatedPipelineRoute;
  "/_authenticated/plataforma": typeof AuthenticatedPlataformaRoute;
  "/_authenticated/produtos": typeof AuthenticatedProdutosRoute;
  "/_authenticated/relatorios": typeof AuthenticatedRelatoriosRoute;
  "/_authenticated/tarefas": typeof AuthenticatedTarefasRoute;
  "/convite/$token": typeof ConviteTokenRoute;
  "/_authenticated/agente-ia/$flowId": typeof AuthenticatedAgenteIaFlowIdRoute;
  "/_authenticated/contatos/$contactId": typeof AuthenticatedContatosContactIdRoute;
  "/_authenticated/formularios/$flowId": typeof AuthenticatedFormulariosFlowIdRoute;
  "/_authenticated/leads/$leadId": typeof AuthenticatedLeadsLeadIdRoute;
  "/_authenticated/typechat/$flowId": typeof AuthenticatedTypechatFlowIdRoute;
  "/_authenticated/agente-ia/": typeof AuthenticatedAgenteIaIndexRoute;
  "/_authenticated/contatos/": typeof AuthenticatedContatosIndexRoute;
  "/_authenticated/formularios/": typeof AuthenticatedFormulariosIndexRoute;
  "/_authenticated/leads/": typeof AuthenticatedLeadsIndexRoute;
  "/_authenticated/typechat/": typeof AuthenticatedTypechatIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/entrar"
    | "/privacidade"
    | "/termos"
    | "/agenda"
    | "/atendimento"
    | "/automacao"
    | "/configuracoes"
    | "/conhecimento"
    | "/conversas"
    | "/marketing"
    | "/painel"
    | "/pipeline"
    | "/plataforma"
    | "/produtos"
    | "/relatorios"
    | "/tarefas"
    | "/convite/$token"
    | "/agente-ia/$flowId"
    | "/contatos/$contactId"
    | "/formularios/$flowId"
    | "/leads/$leadId"
    | "/typechat/$flowId"
    | "/agente-ia/"
    | "/contatos/"
    | "/formularios/"
    | "/leads/"
    | "/typechat/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/entrar"
    | "/privacidade"
    | "/termos"
    | "/agenda"
    | "/atendimento"
    | "/automacao"
    | "/configuracoes"
    | "/conhecimento"
    | "/conversas"
    | "/marketing"
    | "/painel"
    | "/pipeline"
    | "/plataforma"
    | "/produtos"
    | "/relatorios"
    | "/tarefas"
    | "/convite/$token"
    | "/agente-ia/$flowId"
    | "/contatos/$contactId"
    | "/formularios/$flowId"
    | "/leads/$leadId"
    | "/typechat/$flowId"
    | "/agente-ia"
    | "/contatos"
    | "/formularios"
    | "/leads"
    | "/typechat";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/entrar"
    | "/privacidade"
    | "/termos"
    | "/_authenticated/agenda"
    | "/_authenticated/atendimento"
    | "/_authenticated/automacao"
    | "/_authenticated/configuracoes"
    | "/_authenticated/conhecimento"
    | "/_authenticated/conversas"
    | "/_authenticated/marketing"
    | "/_authenticated/painel"
    | "/_authenticated/pipeline"
    | "/_authenticated/plataforma"
    | "/_authenticated/produtos"
    | "/_authenticated/relatorios"
    | "/_authenticated/tarefas"
    | "/convite/$token"
    | "/_authenticated/agente-ia/$flowId"
    | "/_authenticated/contatos/$contactId"
    | "/_authenticated/formularios/$flowId"
    | "/_authenticated/leads/$leadId"
    | "/_authenticated/typechat/$flowId"
    | "/_authenticated/agente-ia/"
    | "/_authenticated/contatos/"
    | "/_authenticated/formularios/"
    | "/_authenticated/leads/"
    | "/_authenticated/typechat/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren;
  EntrarRoute: typeof EntrarRoute;
  PrivacidadeRoute: typeof PrivacidadeRoute;
  TermosRoute: typeof TermosRoute;
  ConviteTokenRoute: typeof ConviteTokenRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/entrar": {
      id: "/entrar";
      path: "/entrar";
      fullPath: "/entrar";
      preLoaderRoute: typeof EntrarRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacidade": {
      id: "/privacidade";
      path: "/privacidade";
      fullPath: "/privacidade";
      preLoaderRoute: typeof PrivacidadeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/termos": {
      id: "/termos";
      path: "/termos";
      fullPath: "/termos";
      preLoaderRoute: typeof TermosRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/agenda": {
      id: "/_authenticated/agenda";
      path: "/agenda";
      fullPath: "/agenda";
      preLoaderRoute: typeof AuthenticatedAgendaRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/atendimento": {
      id: "/_authenticated/atendimento";
      path: "/atendimento";
      fullPath: "/atendimento";
      preLoaderRoute: typeof AuthenticatedAtendimentoRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/automacao": {
      id: "/_authenticated/automacao";
      path: "/automacao";
      fullPath: "/automacao";
      preLoaderRoute: typeof AuthenticatedAutomacaoRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/configuracoes": {
      id: "/_authenticated/configuracoes";
      path: "/configuracoes";
      fullPath: "/configuracoes";
      preLoaderRoute: typeof AuthenticatedConfiguracoesRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/conhecimento": {
      id: "/_authenticated/conhecimento";
      path: "/conhecimento";
      fullPath: "/conhecimento";
      preLoaderRoute: typeof AuthenticatedConhecimentoRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/conversas": {
      id: "/_authenticated/conversas";
      path: "/conversas";
      fullPath: "/conversas";
      preLoaderRoute: typeof AuthenticatedConversasRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/marketing": {
      id: "/_authenticated/marketing";
      path: "/marketing";
      fullPath: "/marketing";
      preLoaderRoute: typeof AuthenticatedMarketingRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/painel": {
      id: "/_authenticated/painel";
      path: "/painel";
      fullPath: "/painel";
      preLoaderRoute: typeof AuthenticatedPainelRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/pipeline": {
      id: "/_authenticated/pipeline";
      path: "/pipeline";
      fullPath: "/pipeline";
      preLoaderRoute: typeof AuthenticatedPipelineRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/plataforma": {
      id: "/_authenticated/plataforma";
      path: "/plataforma";
      fullPath: "/plataforma";
      preLoaderRoute: typeof AuthenticatedPlataformaRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/produtos": {
      id: "/_authenticated/produtos";
      path: "/produtos";
      fullPath: "/produtos";
      preLoaderRoute: typeof AuthenticatedProdutosRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/relatorios": {
      id: "/_authenticated/relatorios";
      path: "/relatorios";
      fullPath: "/relatorios";
      preLoaderRoute: typeof AuthenticatedRelatoriosRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/tarefas": {
      id: "/_authenticated/tarefas";
      path: "/tarefas";
      fullPath: "/tarefas";
      preLoaderRoute: typeof AuthenticatedTarefasRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/convite/$token": {
      id: "/convite/$token";
      path: "/convite/$token";
      fullPath: "/convite/$token";
      preLoaderRoute: typeof ConviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/agente-ia/": {
      id: "/_authenticated/agente-ia/";
      path: "/agente-ia";
      fullPath: "/agente-ia/";
      preLoaderRoute: typeof AuthenticatedAgenteIaIndexRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/agente-ia/$flowId": {
      id: "/_authenticated/agente-ia/$flowId";
      path: "/agente-ia/$flowId";
      fullPath: "/agente-ia/$flowId";
      preLoaderRoute: typeof AuthenticatedAgenteIaFlowIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/contatos/": {
      id: "/_authenticated/contatos/";
      path: "/contatos";
      fullPath: "/contatos/";
      preLoaderRoute: typeof AuthenticatedContatosIndexRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/contatos/$contactId": {
      id: "/_authenticated/contatos/$contactId";
      path: "/contatos/$contactId";
      fullPath: "/contatos/$contactId";
      preLoaderRoute: typeof AuthenticatedContatosContactIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/formularios/": {
      id: "/_authenticated/formularios/";
      path: "/formularios";
      fullPath: "/formularios/";
      preLoaderRoute: typeof AuthenticatedFormulariosIndexRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/formularios/$flowId": {
      id: "/_authenticated/formularios/$flowId";
      path: "/formularios/$flowId";
      fullPath: "/formularios/$flowId";
      preLoaderRoute: typeof AuthenticatedFormulariosFlowIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/leads/": {
      id: "/_authenticated/leads/";
      path: "/leads";
      fullPath: "/leads/";
      preLoaderRoute: typeof AuthenticatedLeadsIndexRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/leads/$leadId": {
      id: "/_authenticated/leads/$leadId";
      path: "/leads/$leadId";
      fullPath: "/leads/$leadId";
      preLoaderRoute: typeof AuthenticatedLeadsLeadIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/typechat/": {
      id: "/_authenticated/typechat/";
      path: "/typechat";
      fullPath: "/typechat/";
      preLoaderRoute: typeof AuthenticatedTypechatIndexRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
    "/_authenticated/typechat/$flowId": {
      id: "/_authenticated/typechat/$flowId";
      path: "/typechat/$flowId";
      fullPath: "/typechat/$flowId";
      preLoaderRoute: typeof AuthenticatedTypechatFlowIdRouteImport;
      parentRoute: typeof AuthenticatedRouteRoute;
    };
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedAgendaRoute: typeof AuthenticatedAgendaRoute;
  AuthenticatedAtendimentoRoute: typeof AuthenticatedAtendimentoRoute;
  AuthenticatedAutomacaoRoute: typeof AuthenticatedAutomacaoRoute;
  AuthenticatedConfiguracoesRoute: typeof AuthenticatedConfiguracoesRoute;
  AuthenticatedConhecimentoRoute: typeof AuthenticatedConhecimentoRoute;
  AuthenticatedConversasRoute: typeof AuthenticatedConversasRoute;
  AuthenticatedMarketingRoute: typeof AuthenticatedMarketingRoute;
  AuthenticatedPainelRoute: typeof AuthenticatedPainelRoute;
  AuthenticatedPipelineRoute: typeof AuthenticatedPipelineRoute;
  AuthenticatedPlataformaRoute: typeof AuthenticatedPlataformaRoute;
  AuthenticatedProdutosRoute: typeof AuthenticatedProdutosRoute;
  AuthenticatedRelatoriosRoute: typeof AuthenticatedRelatoriosRoute;
  AuthenticatedTarefasRoute: typeof AuthenticatedTarefasRoute;
  AuthenticatedAgenteIaFlowIdRoute: typeof AuthenticatedAgenteIaFlowIdRoute;
  AuthenticatedContatosContactIdRoute: typeof AuthenticatedContatosContactIdRoute;
  AuthenticatedFormulariosFlowIdRoute: typeof AuthenticatedFormulariosFlowIdRoute;
  AuthenticatedLeadsLeadIdRoute: typeof AuthenticatedLeadsLeadIdRoute;
  AuthenticatedTypechatFlowIdRoute: typeof AuthenticatedTypechatFlowIdRoute;
  AuthenticatedAgenteIaIndexRoute: typeof AuthenticatedAgenteIaIndexRoute;
  AuthenticatedContatosIndexRoute: typeof AuthenticatedContatosIndexRoute;
  AuthenticatedFormulariosIndexRoute: typeof AuthenticatedFormulariosIndexRoute;
  AuthenticatedLeadsIndexRoute: typeof AuthenticatedLeadsIndexRoute;
  AuthenticatedTypechatIndexRoute: typeof AuthenticatedTypechatIndexRoute;
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedAgendaRoute: AuthenticatedAgendaRoute,
  AuthenticatedAtendimentoRoute: AuthenticatedAtendimentoRoute,
  AuthenticatedAutomacaoRoute: AuthenticatedAutomacaoRoute,
  AuthenticatedConfiguracoesRoute: AuthenticatedConfiguracoesRoute,
  AuthenticatedConhecimentoRoute: AuthenticatedConhecimentoRoute,
  AuthenticatedConversasRoute: AuthenticatedConversasRoute,
  AuthenticatedMarketingRoute: AuthenticatedMarketingRoute,
  AuthenticatedPainelRoute: AuthenticatedPainelRoute,
  AuthenticatedPipelineRoute: AuthenticatedPipelineRoute,
  AuthenticatedPlataformaRoute: AuthenticatedPlataformaRoute,
  AuthenticatedProdutosRoute: AuthenticatedProdutosRoute,
  AuthenticatedRelatoriosRoute: AuthenticatedRelatoriosRoute,
  AuthenticatedTarefasRoute: AuthenticatedTarefasRoute,
  AuthenticatedAgenteIaFlowIdRoute: AuthenticatedAgenteIaFlowIdRoute,
  AuthenticatedContatosContactIdRoute: AuthenticatedContatosContactIdRoute,
  AuthenticatedFormulariosFlowIdRoute: AuthenticatedFormulariosFlowIdRoute,
  AuthenticatedLeadsLeadIdRoute: AuthenticatedLeadsLeadIdRoute,
  AuthenticatedTypechatFlowIdRoute: AuthenticatedTypechatFlowIdRoute,
  AuthenticatedAgenteIaIndexRoute: AuthenticatedAgenteIaIndexRoute,
  AuthenticatedContatosIndexRoute: AuthenticatedContatosIndexRoute,
  AuthenticatedFormulariosIndexRoute: AuthenticatedFormulariosIndexRoute,
  AuthenticatedLeadsIndexRoute: AuthenticatedLeadsIndexRoute,
  AuthenticatedTypechatIndexRoute: AuthenticatedTypechatIndexRoute,
};

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  EntrarRoute: EntrarRoute,
  PrivacidadeRoute: PrivacidadeRoute,
  TermosRoute: TermosRoute,
  ConviteTokenRoute: ConviteTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
